cityWaterTotal={
    "北京": 191981.42,
    "天津": 92374.2,
    "河北": 165810.17,
    "石家庄市": 31042.9,
    "晋州市": 2844.0,
    "新乐市": 1184.0,
    "唐山市": 25536.73,
    "滦州市": 1493.7,
    "遵化市": 1816.0,
    "迁安市": 2610.0,
    "秦皇岛市": 10932.42,
    "邯郸市": 13276.79,
    "武安市": 2159.97,
    "邢台市": 7179.39,
    "南宫市": 812.72,
    "沙河市": 496.0,
    "保定市": 11751.93,
    "涿州市": 3802.12,
    "安国市": 1539.02,
    "高碑店市": 1671.0,
    "白沟新城": 964.0,
    "张家口市": 6374.01,
    "承德市": 6572.99,
    "平泉市": 1147.0,
    "沧州市": 4793.78,
    "泊头市": 1597.5,
    "任丘市": 1852.7,
    "黄骅市": 1029.0,
    "河间市": 1423.56,
    "廊坊市": 5306.69,
    "霸州市": 1407.4,
    "三河市": 2655.0,
    "衡水市": 4526.48,
    "深州市": 1118.11,
    "辛集市": 2505.66,
    "定州市": 2387.6,
    "山西": 98313.12,
    "太原市": 37691.11,
    "古交市": 1914.0,
    "大同市": 12118.0,
    "阳泉市": 4947.75,
    "长治市": 8692.35,
    "潞城市": 526.35,
    "晋城市": 3887.33,
    "高平市": 539.54,
    "朔州市": 2833.95,
    "晋中市": 4188.86,
    "介休市": 1312.58,
    "运城市": 4758.92,
    "永济市": 1498.0,
    "河津市": 1006.66,
    "忻州市": 2503.03,
    "原平市": 1146.93,
    "临汾市": 2913.0,
    "侯马市": 1264.49,
    "霍州市": 831.3,
    "吕梁市": 1467.57,
    "孝义市": 1758.0,
    "汾阳市": 513.4,
    "内蒙古": 82424.04,
    "呼和浩特市": 16335.0,
    "包头市": 18898.5,
    "乌海市": 6889.84,
    "赤峰市": 11918.4,
    "通辽市": 5137.53,
    "霍林郭勒市": 1678.3,
    "鄂尔多斯市": 3934.54,
    "呼伦贝尔市": 3235.15,
    "满洲里市": 1794.6,
    "牙克石": 1218.0,
    "扎兰屯市": 1750.0,
    "额尔古纳市": 155.0,
    "根河市": 187.1,
    "巴彦淖尔市": 2280.11,
    "乌兰察布市": 2028.87,
    "丰镇市": 900.0,
    "乌兰浩特市": 2213.0,
    "阿尔山市": 91.8,
    "二连浩特": 419.0,
    "锡林浩特市": 1359.3,
    "辽宁": 279443.1,
    "沈阳市": 77945.55,
    "新民市": 1655.26,
    "大连市": 58383.07,
    "瓦房店市": 2920.0,
    "庄河市": 1730.0,
    "鞍山市": 15331.0,
    "海城市": 2573.0,
    "抚顺市": 24817.04,
    "本溪市": 7203.0,
    "丹东市": 7208.0,
    "东港市": 2043.0,
    "凤城市": 1361.0,
    "锦州市": 10132.0,
    "凌海市": 473.0,
    "北镇市": 742.43,
    "营口市": 11397.0,
    "盖州市": 1383.69,
    "大石桥市": 1783.58,
    "阜新市": 7199.3,
    "辽阳市": 10357.3,
    "灯塔市": 1124.41,
    "盘锦市": 10259.84,
    "铁岭市": 3123.67,
    "调兵山市": 2092.5,
    "开原市": 1312.34,
    "朝阳市": 5850.5,
    "北票市": 1374.11,
    "凌源市": 1520.0,
    "葫芦岛市": 5195.0,
    "兴城市": 952.51,
    "吉林": 105505.05,
    "长春市": 39439.1,
    "榆树市": 1165.0,
    "德惠市": 937.45,
    "吉林市": 18797.0,
    "蛟河市": 876.87,
    "桦甸市": 773.5,
    "舒兰市": 512.37,
    "磐石市": 829.0,
    "四平市": 3338.54,
    "双辽市": 2747.71,
    "辽源市": 4757.77,
    "通化市": 4410.19,
    "集安市": 923.25,
    "白山市": 2608.04,
    "临江市": 462.0,
    "松原市": 4201.01,
    "扶余市": 588.1,
    "白城市": 2067.55,
    "洮南市": 832.52,
    "大安市": 658.95,
    "延吉市": 5389.96,
    "图们市": 450.2,
    "敦化市": 1171.68,
    "珲春市": 1546.0,
    "龙井市": 873.0,
    "和龙市": 869.0,
    "公主岭市": 2034.25,
    "梅河口市": 1382.58,
    "长白山保护开发区管理委员会": 862.46,
    "黑龙江": 139709.92,
    "哈尔滨市": 44367.21,
    "尚志市": 1406.52,
    "五常市": 1244.0,
    "齐齐哈尔市": 8354.25,
    "讷河市": 400.42,
    "鸡西市": 5041.4,
    "虎林市": 479.0,
    "密山市": 700.0,
    "鹤岗市": 3851.93,
    "双鸭山市": 4198.27,
    "大庆市": 30328.0,
    "伊春市": 4190.22,
    "铁力市": 1064.0,
    "佳木斯市": 5797.34,
    "同江市": 370.0,
    "富锦市": 745.3,
    "抚远市": 271.0,
    "七台河市": 3491.72,
    "牡丹江市": 10967.8,
    "海林市": 721.13,
    "宁安市": 616.0,
    "穆棱市": 455.88,
    "绥芬河市": 1207.02,
    "东宁市": 582.0,
    "黑河市": 990.0,
    "北安市": 997.0,
    "五大连池市": 230.0,
    "绥化市": 3398.43,
    "安达市": 1022.0,
    "肇东市": 1709.7,
    "海伦市": 512.38,
    "上海": 305507.87,
    "江苏": 560242.05,
    "南京市": 133978.07,
    "无锡市": 45821.78,
    "江阴市": 7636.0,
    "宜兴市": 7959.34,
    "徐州市": 31805.27,
    "新沂市": 3537.0,
    "邳州市": 3367.0,
    "常州市": 36090.06,
    "溧阳市": 3849.97,
    "苏州市": 78082.06,
    "常熟市": 10590.41,
    "张家港市": 4708.0,
    "昆山市": 17056.24,
    "太仓市": 4175.83,
    "南通市": 29768.01,
    "海安市": 3679.97,
    "启东市": 2922.02,
    "如皋市": 4031.55,
    "海门市": 3986.52,
    "连云港市": 12181.59,
    "淮安市": 22218.11,
    "盐城市": 11671.5,
    "东台市": 2290.75,
    "扬州市": 20563.41,
    "仪征市": 3887.35,
    "高邮市": 2588.93,
    "镇江市": 16326.92,
    "丹阳市": 3585.67,
    "扬中市": 1974.3,
    "句容市": 3140.29,
    "泰州市": 10669.0,
    "兴化市": 1402.0,
    "靖江市": 2890.4,
    "泰兴市": 2961.02,
    "宿迁市": 8845.71,
    "浙江": 371711.29,
    "杭州市": 88568.27,
    "建德市": 1880.0,
    "宁波市": 61845.97,
    "余姚市": 5991.02,
    "慈溪市": 6776.24,
    "温州市": 29506.3,
    "瑞安市": 2574.72,
    "乐清市": 4072.84,
    "嘉兴市": 9246.8,
    "海宁市": 5059.1,
    "平湖市": 3157.06,
    "桐乡市": 6778.27,
    "湖州市": 10538.33,
    "绍兴市": 43006.04,
    "诸暨市": 7523.84,
    "嵊州市": 4683.91,
    "金华市": 10254.7,
    "兰溪市": 2879.35,
    "义乌市": 11272.21,
    "东阳市": 5315.76,
    "永康市": 4257.64,
    "衢州市": 6690.5,
    "江山市": 1651.92,
    "舟山市": 5523.0,
    "台州市": 18064.64,
    "玉环市": 1623.0,
    "温岭市": 3501.8,
    "临海市": 3835.8,
    "丽水市": 4702.72,
    "龙泉市": 929.54,
    "安徽": 200823.56,
    "合肥市": 57962.9,
    "巢湖市": 2916.0,
    "芜湖市": 19346.83,
    "蚌埠市": 18442.85,
    "淮南市": 9716.23,
    "马鞍山市": 13611.51,
    "淮北市": 5938.0,
    "铜陵市": 7790.0,
    "安庆市": 8785.62,
    "潜山市": 1353.93,
    "桐城市": 1499.6,
    "黄山市": 4837.37,
    "滁州市": 8267.22,
    "天长市": 1905.0,
    "明光市": 1643.24,
    "阜阳市": 8495.67,
    "界首市": 1316.4,
    "宿州市": 5833.25,
    "六安市": 7320.62,
    "亳州市": 4795.85,
    "池州市": 3479.0,
    "宣城市": 3906.13,
    "宁国市": 1660.34,
    "福建": 175159.11,
    "福州市": 46976.25,
    "福清市": 6663.65,
    "厦门市": 47187.16,
    "莆田市": 7934.44,
    "三明市": 3401.53,
    "永安市": 2206.09,
    "泉州市": 15048.34,
    "石狮市": 5119.89,
    "晋江市": 7100.0,
    "南安市": 2070.86,
    "漳州市": 8037.0,
    "龙海市": 1150.0,
    "南平市": 4146.89,
    "邵武市": 1105.21,
    "武夷山市": 1106.26,
    "建瓯市": 768.2,
    "龙岩市": 7052.88,
    "漳平市": 1043.6,
    "宁德市": 2506.98,
    "福安市": 2065.23,
    "福鼎市": 2468.65,
    "江西": 130712.04,
    "南昌市": 43678.34,
    "景德镇市": 6275.27,
    "乐平市": 1935.69,
    "萍乡市": 3574.69,
    "九江市": 10433.0,
    "瑞昌市": 1380.98,
    "共青城市": 704.6,
    "庐山市": 644.0,
    "新余市": 6071.0,
    "鹰潭市": 3221.0,
    "贵溪市": 1318.0,
    "赣州市": 15479.55,
    "瑞金市": 1410.0,
    "吉安市": 4808.0,
    "井冈山市": 205.5,
    "宜春市": 6017.8,
    "丰城市": 2406.99,
    "樟树市": 2053.42,
    "高安市": 1975.0,
    "抚州市": 7501.0,
    "上饶市": 9170.21,
    "德兴市": 448.0,
    "山东": 394787.92,
    "济南市": 48985.94,
    "青岛市": 53234.88,
    "胶州市": 3775.49,
    "平度市": 3501.0,
    "莱西市": 2915.89,
    "淄博市": 26170.13,
    "枣庄市": 9029.78,
    "滕州市": 5570.0,
    "东营市": 16796.1,
    "烟台市": 19360.16,
    "龙口市": 1835.05,
    "莱阳市": 1562.98,
    "莱州市": 2061.0,
    "蓬莱市": 1641.5,
    "招远市": 1715.73,
    "栖霞市": 820.0,
    "海阳市": 1508.6,
    "潍坊市": 16811.38,
    "青州市": 3709.0,
    "诸城市": 7701.0,
    "寿光市": 6994.6,
    "安丘市": 4355.0,
    "高密市": 7172.0,
    "昌邑市": 4361.0,
    "济宁市": 15798.13,
    "曲阜市": 3070.0,
    "邹城市": 3675.48,
    "泰安市": 7893.92,
    "新泰市": 3072.65,
    "肥城市": 1904.0,
    "威海市": 9261.04,
    "荣成市": 2668.1,
    "乳山市": 1802.0,
    "日照市": 7917.89,
    "莱芜市": 4424.7,
    "临沂市": 24316.73,
    "德州市": 13097.52,
    "乐陵市": 2189.41,
    "禹城市": 3003.53,
    "聊城市": 10734.0,
    "临清市": 3215.35,
    "滨州市": 10959.76,
    "邹平市": 6330.68,
    "菏泽市": 7864.82,
    "河南": 216304.96,
    "郑州市": 42097.9,
    "巩义市": 1772.7,
    "荥阳市": 1876.8,
    "新密市": 1301.03,
    "新郑市": 1647.99,
    "登封市": 1067.8,
    "开封市": 11747.49,
    "洛阳市": 17030.9,
    "偃师市": 1145.5,
    "平顶山市": 12545.05,
    "舞钢市": 1466.6,
    "汝州市": 1768.0,
    "安阳市": 10489.0,
    "林州市": 1420.0,
    "鹤壁市": 4413.46,
    "新乡市": 13717.79,
    "卫辉市": 1844.0,
    "辉县市": 2344.0,
    "焦作市": 8376.7,
    "沁阳市": 602.33,
    "孟州市": 963.5,
    "濮阳市": 7457.1,
    "许昌市": 5006.3,
    "禹州市": 2251.3,
    "长葛市": 1669.0,
    "漯河市": 7206.62,
    "三门峡市": 3180.46,
    "义马市": 2309.8,
    "灵宝市": 2370.0,
    "南阳市": 10077.7,
    "邓州市": 1984.0,
    "商丘市": 5975.0,
    "永城市": 3246.0,
    "信阳市": 5005.08,
    "周口市": 5059.25,
    "项城市": 2862.0,
    "驻马店市": 7308.81,
    "济源市": 3698.0,
    "湖北": 305003.07,
    "武汉市": 149821.37,
    "黄石市": 10692.06,
    "大冶市": 2253.0,
    "十堰市": 13186.86,
    "丹江口市": 1126.9,
    "宜昌市": 15500.2,
    "宜都市": 1673.5,
    "当阳市": 2572.97,
    "枝江市": 2052.18,
    "襄阳市": 16071.19,
    "老河口市": 2141.38,
    "枣阳市": 2213.0,
    "宜城市": 1331.92,
    "鄂州市": 5046.6,
    "荆门市": 7963.28,
    "钟祥市": 2282.0,
    "孝感市": 6052.8,
    "应城市": 1898.56,
    "安陆市": 2261.04,
    "汉川市": 3565.2,
    "荆州市": 8659.79,
    "石首市": 1302.18,
    "洪湖市": 1891.42,
    "松滋市": 1173.0,
    "黄冈市": 4574.0,
    "麻城市": 2129.02,
    "武穴市": 3730.0,
    "咸宁市": 4398.11,
    "赤壁市": 2619.0,
    "随州市": 4435.0,
    "广水市": 2423.56,
    "恩施市": 4473.28,
    "利川市": 1757.0,
    "仙桃市": 5528.0,
    "潜江市": 4363.9,
    "天门市": 1839.8,
    "湖南": 218567.86,
    "长沙市": 67721.87,
    "宁乡市": 4440.16,
    "浏阳市": 2403.1,
    "株洲市": 19120.64,
    "醴陵市": 2612.63,
    "湘潭市": 12528.5,
    "湘乡市": 1375.0,
    "韶山市": 410.5,
    "衡阳市": 17094.0,
    "耒阳市": 3610.7,
    "常宁市": 1953.0,
    "邵阳市": 9438.0,
    "武冈市": 1840.0,
    "岳阳市": 9849.71,
    "汨罗市": 1344.23,
    "临湘市": 991.0,
    "常德市": 9887.98,
    "津市市": 1207.1,
    "张家界市": 3571.0,
    "益阳市": 6726.71,
    "沅江市": 1164.5,
    "郴州市": 8689.82,
    "资兴市": 1450.0,
    "永州市": 9379.21,
    "怀化市": 7062.34,
    "洪江市": 1043.44,
    "娄底市": 5848.54,
    "冷水江市": 1618.13,
    "涟源市": 1228.0,
    "吉首市": 2958.05,
    "广东": 938248.32,
    "广州市": 248103.48,
    "韶关市": 10467.96,
    "乐昌市": 1258.34,
    "南雄市": 1005.6,
    "深圳市": 179498.0,
    "珠海市": 58766.12,
    "汕头市": 28966.84,
    "佛山市": 42516.65,
    "江门市": 27889.81,
    "台山市": 3489.74,
    "开平市": 3024.66,
    "鹤山市": 2349.5,
    "恩平市": 1984.4,
    "湛江市": 13524.24,
    "廉江市": 3037.0,
    "雷州市": 1533.0,
    "吴川市": 1842.0,
    "茂名市": 8566.21,
    "高州市": 2423.0,
    "化州市": 1783.05,
    "信宜市": 1725.0,
    "肇庆市": 16276.54,
    "四会市": 4574.0,
    "惠州市": 29962.97,
    "梅州市": 6388.71,
    "兴宁市": 3438.22,
    "汕尾市": 5917.0,
    "陆丰市": 2116.0,
    "河源市": 6074.84,
    "阳江市": 8873.36,
    "阳春市": 1511.0,
    "清远市": 10648.47,
    "英德市": 2369.91,
    "连州市": 1109.0,
    "东莞市": 151347.44,
    "中山市": 12999.68,
    "潮州市": 10751.96,
    "揭阳市": 7789.87,
    "普宁市": 5680.0,
    "云浮市": 4111.75,
    "罗定市": 2553.0,
    "广西": 177234.11,
    "南宁市": 59696.29,
    "柳州市": 32227.88,
    "桂林市": 15103.33,
    "荔浦市": 1119.47,
    "梧州市": 7518.81,
    "岑溪市": 1664.35,
    "北海市": 7795.27,
    "防城港市": 5807.32,
    "东兴市": 1425.0,
    "钦州市": 6741.29,
    "贵港市": 7385.16,
    "桂平市": 3041.35,
    "玉林市": 7729.06,
    "北流市": 1966.0,
    "百色市": 3625.68,
    "靖西市": 930.0,
    "贺州市": 2258.9,
    "河池市": 4276.5,
    "来宾市": 3316.85,
    "合山市": 387.0,
    "崇左市": 2469.6,
    "凭祥市": 749.0,
    "海南": 42880.55,
    "海口市": 22259.11,
    "三亚市": 11858.72,
    "三沙市": 20.47,
    "儋州市": 2982.3,
    "五指山市": 526.0,
    "琼海市": 1561.23,
    "文昌市": 1517.46,
    "万宁市": 975.26,
    "东方市": 1180.0,
    "重庆": 149303.79,
    "重庆市": 149303.79,
    "四川": 258676.09,
    "成都市": 109274.78,
    "都江堰市": 4204.14,
    "彭州市": 2118.41,
    "邛崃市": 2165.6,
    "崇州市": 2129.17,
    "简阳市": 2384.86,
    "自贡市": 6783.02,
    "攀枝花市": 11922.25,
    "泸州市": 11606.53,
    "德阳市": 7146.53,
    "广汉市": 3341.36,
    "什邡市": 1777.0,
    "绵竹市": 1495.09,
    "绵阳市": 12223.71,
    "江油市": 2659.5,
    "广元市": 5204.7,
    "遂宁市": 6854.62,
    "内江市": 5084.7,
    "隆昌市": 1460.0,
    "乐山市": 5930.09,
    "峨眉山市": 2305.0,
    "南充市": 10375.0,
    "阆中市": 2751.0,
    "眉山市": 4862.2,
    "宜宾市": 7323.62,
    "广安市": 3145.61,
    "华蓥市": 746.7,
    "达州市": 5978.2,
    "万源市": 793.62,
    "雅安市": 2375.4,
    "巴中市": 3417.0,
    "资阳市": 2752.53,
    "马尔康市": 417.15,
    "康定市": 439.0,
    "西昌市": 5228.0,
    "贵州": 80560.06,
    "贵阳市": 38352.66,
    "清镇市": 1550.0,
    "六盘水市": 3649.16,
    "盘州市": 1099.5,
    "遵义市": 10142.95,
    "赤水市": 829.8,
    "仁怀市": 1891.2,
    "安顺市": 4182.39,
    "毕节市": 3445.0,
    "铜仁市": 3798.63,
    "兴义市": 3080.36,
    "兴仁市": 1227.89,
    "凯里市": 3442.51,
    "都匀市": 2807.01,
    "福泉市": 1061.0,
    "云南": 98721.58,
    "昆明市": 48742.13,
    "安宁市": 2532.06,
    "曲靖市": 5990.24,
    "宣威市": 1214.0,
    "玉溪市": 3653.81,
    "保山市": 1971.59,
    "腾冲市": 1413.2,
    "昭通市": 2496.0,
    "丽江市": 2773.16,
    "普洱市": 2225.0,
    "临沧市": 1204.0,
    "楚雄市": 3347.8,
    "个旧市": 1396.66,
    "开远市": 1394.78,
    "蒙自市": 2652.75,
    "弥勒市": 1097.0,
    "文山市": 2954.91,
    "景洪市": 2555.47,
    "大理市": 5073.36,
    "瑞丽市": 1615.0,
    "芒市": 1204.0,
    "泸水市": 496.46,
    "香格里拉市": 718.2,
    "西藏": 10265.51,
    "拉萨市": 5819.0,
    "日喀则市": 1400.23,
    "昌都市": 587.0,
    "林芝市": 882.0,
    "山南市": 734.0,
    "那曲市": 843.28,
    "陕西": 141971.89,
    "西安市": 89259.52,
    "铜川市": 2606.0,
    "宝鸡市": 7899.99,
    "咸阳市": 13804.61,
    "彬州市": 390.15,
    "兴平市": 3200.78,
    "渭南市": 6712.5,
    "韩城市": 1090.6,
    "华阴市": 705.0,
    "延安市": 2899.13,
    "汉中市": 4071.05,
    "榆林市": 3072.0,
    "神木市": 1340.86,
    "安康市": 2391.0,
    "商洛市": 1258.7,
    "杨凌区": 1270.0,
    "甘肃": 53877.82,
    "兰州市": 27637.6,
    "嘉峪关市": 1730.0,
    "金昌市": 2824.17,
    "白银市": 2354.0,
    "天水市": 3431.75,
    "武威市": 3063.97,
    "张掖市": 2812.0,
    "平凉市": 1145.08,
    "华亭市": 515.0,
    "酒泉市": 2648.0,
    "玉门市": 375.0,
    "敦煌市": 791.0,
    "庆阳市": 857.25,
    "定西市": 760.0,
    "陇南市": 650.0,
    "临夏市": 1995.0,
    "合作市": 288.0,
    "青海": 26959.31,
    "西宁市": 15141.3,
    "海东市": 1175.7,
    "玉树市": 809.1,
    "格尔木市": 6699.05,
    "德令哈市": 3134.16,
    "宁夏": 29956.41,
    "银川市": 14119.43,
    "灵武市": 959.78,
    "宁东能源化工基地": 161.1,
    "石嘴山市": 7926.48,
    "吴忠市": 3123.62,
    "青铜峡市": 1213.0,
    "固原市": 1410.0,
    "中卫市": 1043.0,
    "新疆": 103207.95,
    "乌鲁木齐市": 33694.0,
    "克拉玛依市": 14075.23,
    "吐鲁番市": 1141.41,
    "哈密市": 4738.0,
    "昌吉市": 2669.0,
    "阜康市": 801.59,
    "博乐市": 908.65,
    "阿拉山口市": 529.51,
    "库尔勒市": 7785.52,
    "阿克苏市": 3800.0,
    "阿图什市": 889.0,
    "喀什市": 4609.6,
    "和田市": 2309.0,
    "伊宁市": 4847.0,
    "奎屯市": 2275.0,
    "霍尔果斯市": 390.0,
    "塔城市": 1042.2,
    "乌苏市": 1451.41,
    "阿勒泰市": 650.0,
    "石河子市": 9483.0,
    "阿拉尔市": 912.4,
    "图木舒克市": 373.0,
    "五家渠市": 1101.0,
    "北屯市": 1387.02,
    "铁门关市": 215.41,
    "双河市": 150.0,
    "可克达拉市": 655.0,
    "昆玉市": 325.0
}